import Dashboard from './DashboardComponent';
import './dashboard.scss';

export default Dashboard;